import React from 'react'
import './header.css'

const Header = () => {
  return (
    <div className="header__container">
        thoughtful
    </div>
  );
}

export default Header